export const NetConfig = [
  {
    IsOpen:true,
    key: 'BNB',
    NetWorkName: 'BNB Chain',
    logoURI:  require('@/assets/tokenlogo/BNBnetwork.png'),
    Url: 'https://bsc-dataseed4.defibit.io/',
    blocsUrl: 'https://bscscan.com/tx/',
    blocsHashUrl: 'https://bscscan.com/token/',
    swapConfig: {
      jackRouter: '0x689C1553c9A5af44da2d9B362a714596ee7a2fE9',
      jackFactory: '0x184736bc80Ef36cE2DC768cd780b3530469fb233',
      weth: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    },
    chainId: "0x38",
    TokenBNB: {
      name: 'BNB',
      symbol: 'BNB',
      address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      chainId: 56,
      decimals: 18,
      logoURI: require('@/assets/tokenlogo/BNB.png'),
    }
  },
  {
    IsOpen:false,
    key: 'Polygon',
    NetWorkName: 'Polygon',
    logoURI: require('@/assets/tokenlogo/polygon.png'),
    Url: 'https://1rpc.io/matic',
    blocsUrl: 'https://polygonscan.com/tx/',
    blocsHashUrl: 'https://polygonscan.com/token/',
    swapConfig: {
      jackRouter: '0x4a9ba795bd79d4ffa6126762a4bea757cb2315cb',
      jackFactory: '0x9ccb9a679ac05cb05569ff9916a6d56352d3f587',
      weth: '0xcF1e5136A17b61E12220d3CD4665a707A2690d0a',
    },
    chainId: "0x89",
    TokenBNB: {
      name: 'MATIC',
      symbol: 'MATIC',
      address: '0xcF1e5136A17b61E12220d3CD4665a707A2690d0a',
      chainId: 137,
      decimals: 18,
      logoURI: require('@/assets/tokenlogo/polygon.png'),
    }
  },

  {
    IsOpen:false,
    key: 'Arbitrum',
    NetWorkName: 'Arbitrum',
    logoURI: require('@/assets/tokenlogo/arbitrum.jpg'),
    Url: 'https://rpchttp.kadsea.org',
    blocsUrl: 'https://kadscan.kadsea.org/tx/',
    blocsHashUrl: 'https://kadscan.kadsea.org/token/',
    swapConfig: {
      jackRouter: '0xc8c0a9F0269384be391ae168EAb890de706C3e5A',
      jackFactory: '0xD1b46141fd853fdCB6467A0844A16cf147d56ed7',
      weth: '0xAa8FBD654000E9Fa5c2eDC3179C3C3100ebd53bB',
    },
    chainId: "0x36E",
    TokenBNB: {
      name: 'KAD',
  symbol: 'KAD',
  address: '0xAa8FBD654000E9Fa5c2eDC3179C3C3100ebd53bB',
  chainId: 878,
  decimals: 18,
  logoURI: require('@/assets/tokenlogo/KAD.png'),
    }
  },
  {
    IsOpen:false,
    key: 'TRX',
    NetWorkName: 'TRX',
    logoURI: require('@/assets/tokenlogo/tron.png'),
    Url: 'https://rpchttp.kadsea.org',
    blocsUrl: 'https://kadscan.kadsea.org/tx/',
    blocsHashUrl: 'https://kadscan.kadsea.org/token/',
    swapConfig: {
      jackRouter: '0xc8c0a9F0269384be391ae168EAb890de706C3e5A',
      jackFactory: '0xD1b46141fd853fdCB6467A0844A16cf147d56ed7',
      weth: '0xAa8FBD654000E9Fa5c2eDC3179C3C3100ebd53bB',
    },
    chainId: "0x36E",
    TokenBNB: {
      name: 'KAD',
  symbol: 'KAD',
  address: '0xAa8FBD654000E9Fa5c2eDC3179C3C3100ebd53bB',
  chainId: 878,
  decimals: 18,
  logoURI: require('@/assets/tokenlogo/KAD.png'),
    }
  },
  {
    IsOpen:false,
    key: 'Solana',
    NetWorkName: 'Solana',
    logoURI: require('@/assets/tokenlogo/solana.png'),
    Url: 'https://rpchttp.kadsea.org',
    blocsUrl: 'https://kadscan.kadsea.org/tx/',
    blocsHashUrl: 'https://kadscan.kadsea.org/token/',
    swapConfig: {
      jackRouter: '0xc8c0a9F0269384be391ae168EAb890de706C3e5A',
      jackFactory: '0xD1b46141fd853fdCB6467A0844A16cf147d56ed7',
      weth: '0xAa8FBD654000E9Fa5c2eDC3179C3C3100ebd53bB',
    },
    chainId: "0x36E",
    TokenBNB: {
      name: 'KAD',
  symbol: 'KAD',
  address: '0xAa8FBD654000E9Fa5c2eDC3179C3C3100ebd53bB',
  chainId: 878,
  decimals: 18,
  logoURI: require('@/assets/tokenlogo/KAD.png'),
    }
  },
]